import MenuSelector from "@arelia-components/ui-atoms/menu-selector/MenuSelector";
import { MenuType } from "@arelia-components/ui-atoms/menu-selector/models";
import { Box } from "@mui/material";
import { sortByMenu } from "../constant";
import { FansSorting } from "../models";

type Props = {
  sortFansBy: FansSorting;
  setSortFansBy: (value: FansSorting) => void;
}

export function FansFilters({
  sortFansBy,
  setSortFansBy,
}: Props) {
 
  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.filters}>
        <MenuSelector
          menuType={MenuType.contained}
          menuItems={sortByMenu}
          selectedValue={sortFansBy}
          onClick={setSortFansBy}
        ></MenuSelector>
      </Box>
    </Box>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  filters: {
    display: "flex",
    gap: "20px",
    alignItems: "center"
  },
  select: {
    bgcolor: 'white',
    margin: '0'
  }
}